import { call, put, select, takeLatest } from 'typed-redux-saga'
import {
	errorHandler,
	NOTIFICATION_TYPE,
	notifyMessageCreator,
	loadersSlice,
	gridSlice,
} from 'Modules'
import { RequestParams, ResponseCatalog } from 'Models'
import {
	massUpdateCuratorApi,
	MassUpdateCuratorNS,
	massUpdateCuratorSelectors,
	massUpdateCuratorSlice,
	PartnerMassUpdateModel,
} from 'Pages/pp'
import { FormNames } from 'Constants/FormNames'

import { Deserialize } from 'cerialize'

function* getAll(action: MassUpdateCuratorNS.GetAll) {
	try {
		const { params, clear } = action.payload
		yield* put(gridSlice.actions.setLoading(true))
		if (clear) {
			yield* put(massUpdateCuratorSlice.actions.clearAll())
		}
		const res = yield* call(massUpdateCuratorApi.getAll, params)
		const items = new ResponseCatalog<PartnerMassUpdateModel>(res)
		items.entries = items.entries.map(
			(item): PartnerMassUpdateModel => Deserialize(item, PartnerMassUpdateModel)
		)
		if (!clear) {
			const oldItems = yield* select(massUpdateCuratorSelectors.getAll)
			items.entries = [...oldItems.entries, ...items.entries]
		}
		yield* put(massUpdateCuratorSlice.actions.setAll(items))
		yield* put(massUpdateCuratorSlice.actions.setRequestParams(params))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

function* massUpdate(action: MassUpdateCuratorNS.MassUpdate) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { manager_id, params } = action.payload
		yield* call(massUpdateCuratorApi.update, manager_id, params)
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(notifyMessageCreator, 'mass_update_curator.update.error', {
			options: { type: NOTIFICATION_TYPE.ERROR },
		})
		yield* call(errorHandler, error, FormNames.PP.MASS_UPDATE_CURATOR)
	}
}

function* getAllSocket(action: MassUpdateCuratorNS.GetAllSocket) {
	try {
		const { source_manager_id } = action.payload
		const requestParams = yield* select(massUpdateCuratorSelectors.getRequestParams)
		if (!source_manager_id) {
			yield* call(notifyMessageCreator, 'mass_update_curator.socket.error', {
				options: { type: NOTIFICATION_TYPE.ERROR },
			})
		} else if (source_manager_id === requestParams?.manager_id) {
			yield* call(notifyMessageCreator, 'mass_update_curator.update.success')
			yield* put(
				massUpdateCuratorSlice.actions.getAll({
					params: Object.assign(new RequestParams(), requestParams, { page: 1 }),
					clear: true,
				})
			)
		}
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* massUpdateFile(action: MassUpdateCuratorNS.MassUpdateFile) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { manager_id, file, callback } = action.payload
		yield* call(massUpdateCuratorApi.updateFile, manager_id, file)
		callback?.()
	} catch (error) {
		yield* call(notifyMessageCreator, 'mass_update_curator.update.error', {
			options: { type: NOTIFICATION_TYPE.ERROR },
		})
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* massUpdateCuratorSaga() {
	yield* takeLatest(massUpdateCuratorSlice.actions.getAll, getAll)
	yield* takeLatest(massUpdateCuratorSlice.actions.massUpdate, massUpdate)
	yield* takeLatest(massUpdateCuratorSlice.actions.getAllSocket, getAllSocket)
	yield* takeLatest(massUpdateCuratorSlice.actions.massUpdateFile, massUpdateFile)
}
